import React from 'react';
import Footer from 'cccisd-footer';
import BHALogo from './BHALogo.svg';
import { Link } from 'cccisd-react-router';
import style from './style.css';
import { publicLinks } from '../Header';

const BHAFooter = () => {
    return (
        <div className={style.footerWrapper}>
            <div className={style.topSection + ' container'}>
                <div className={style.rightSide}>
                    <img src={BHALogo} alt="BHA Logo" className={style.logo} />
                    <div className={style.text}>
                        <p>Behavioral Health Administration</p>
                        <p>55 Wade Avenue Catonsville, MD 21228</p>
                        <p>(410) 402-8600</p>
                    </div>
                </div>
                <div className={style.leftSide}>
                    <ul className={style.links}>
                        {publicLinks.map(link => (
                            <li key={link.url}>
                                {/^http/.test(link.url) ? (
                                    <a href={link.url}>{link.label}</a>
                                ) : (
                                    <Link to={link.url}>{link.label}</Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className={style.bottomSection}>
                <Footer />
            </div>
        </div>
    );
};

export default BHAFooter;
